import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Constants from 'style/constants';
import { HistoryItemType } from 'shared/components/timeline/enums/history-item-type';
import { TimelineItemType } from 'shared/enums/timeline-item-type';

import Duration from './duration';
import Line from './line';
import TimelineItem from './types/timeline-item';

import './timeline.scss';

type Props = {
  historyItemType: HistoryItemType;
  items: TimelineItem[];
  showOpenChip: boolean;
};

const Timeline = ({ historyItemType, items, showOpenChip }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('timeline');

  return (
    <div className="timeline-component-container">
      {items.map((item, index) => (
        <div key={`timeline-item-${item.id}`} className={`timeline-item-row ${item.isHighlighted ? 'highlighted' : ''}`}>
          <Line item={item} isFirstItem={index === 0} isLastItem={index === items.length - 1} showOpenChip={showOpenChip} />
          <div className={`information-column ${index === 0 ? 'first-item' : ''} ${item.isHighlighted ? 'highlighted' : ''}`}>
            <Typography variant="subtitle1">
              {historyItemType === HistoryItemType.Status && <>{t('state_changed_to')} </>}
              {item.title}
            </Typography>
            {item.timeLineType !== TimelineItemType.Created &&
              item.users.map((user) => (
                <Typography key={`timeline-item-${item.id}-user-${user}`} variant="caption">
                  {user}
                </Typography>
              ))}
          </div>
          <div className={`information-column time-column ${index === 0 ? 'first-item' : ''} ${item.isHighlighted ? 'highlighted' : ''}`}>
            <Typography variant="overline" sx={{ color: Constants.Colors.onSurface }}>
              {moment(item.createdOn).format('DD-MM-YYYY · HH:mm').toString()}
            </Typography>
            {index !== 0 && (
              <Duration
                typographyVariant="overline"
                prefix={t('after')}
                firstItem={items[0]}
                secondItem={item}
                durationInMinutes={0}
                usePreCalculatedTime={false}
              />
            )}
          </div>
        </div>
      ))}

      {showOpenChip && (
        <div className="open-chip">
          <Typography variant="overline" sx={{ color: Constants.Colors.onSurface }}>
            {t('open')}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Timeline;
